import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import Edmond from '../components/edi/edi.jsx';
import EuroViewCheckout from '../components/euroview/EuroViewCheckout.jsx';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Edmond />} />
        <Route path='/checkout' element={<EuroViewCheckout />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
